module.exports = __webpack_public_path__ + "static/media/facileristrutturare-card.90c03527.jpg";